import React from 'react';

export interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Action buttons rendered on the right. */
  actions?: React.ReactNode;
  /** Deprecated: the Back button was removed (breadcrumbs handle navigation). Kept optional so existing call sites don't break. */
  showBack?: boolean;
}

/**
 * Standard page header: title + optional subtitle on the left, an
 * action button row on the right with an inline Back button as the
 * last (rightmost) button.
 *
 * Renders a hidden marker element so the global floating Back button
 * in Layout is auto-suppressed via CSS :has() — no path lists needed.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <div className="rd-page-header-row">
      <div className="rd-page-header-text">
        <h1 className="rd-page-title">{title}</h1>
        {subtitle && <p className="rd-page-subtitle">{subtitle}</p>}
      </div>
      <div className="rd-page-header-actions">{actions}</div>
    </div>
  );
};

export default PageHeader;
